const Condition = require( './Condition' );

const ArmorBrokenCondition = function( instigator, owner, battleState, potency ) {
	const condition = new Condition( instigator, owner, battleState, potency );
	condition.handle = 'armor_broken';
	condition.ConditionClass = ArmorBrokenCondition;

	return condition;
};

ArmorBrokenCondition.fromCopy = function(cState, owner, instigator, battleState) {
	return ArmorBrokenCondition(instigator, owner, battleState, cState.potency);
};

module.exports = ArmorBrokenCondition
